import { FC } from 'react'

import TrashIcon from 'src/components/ui/atoms/Icons/TrashIcon'
import DropdownMenuItem from '../../../atoms/DropdownMenuItem'
import { usePageHeaderDashboardMenuContext } from '../PageHeaderDashboardMenuProvider'

const DeleteDashboardMenu: FC = () => {
  const { setModalOpened } = usePageHeaderDashboardMenuContext()
  return (
    <DropdownMenuItem
      icon={
        <TrashIcon width={undefined} height={undefined} className="text-flush-mahogany size-4" />
      }
      label="Delete"
      data-testid="header-dashboard-menu-delete"
      onClick={() => setModalOpened('delete')}
      className="text-flush-mahogany"
      classes={{
        hoverLabel: 'text-mine-shaft',
      }}
    />
  )
}

export default DeleteDashboardMenu
